import styles from "./SocialMedia.module.scss";

const SocialMedia = ({ data }) => {
  return (
    <a
      href={"https://www.google.com"}
      target={"_blank"}
      rel={"noreferrer"}
      className={styles["social-media"]}
    >
      {data.icon}
      <p>{data.title}</p>
    </a>
  );
};

export default SocialMedia;
